import { Injectable } from '@angular/core';
import { ConfigurationService } from './../services/configuration.service';

@Injectable()
export class TranslatesService {

  constructor(private configurationService: ConfigurationService) { }

  public texts = {
    'start-page-title': {
      pl: 'Gra terenowa',
      cz: 'Terénní hra'
    },
    'ranking-page-title': {
      pl: 'Ranking',
      cz: 'Pořadí'
    },
    'result-page-title': {
      pl: 'Rezultat',
      cz: 'Výsledky na'
    },
    'trip-page-title': {
      pl: 'Wycieczka',
      cz: 'prohlídka'
    },
    'header-text': {
      pl: 'Zapraszamy na wycieczkę po Nysie zwanej „Śląskim Rzymem” oraz po partnerskim mieście Nysy, Szumperku zwanym „Małym Wiedniem”.',
      cz: 'Zveme Vás na výlet po Nise zvané „Slezský Řím” a také po partnerském městě Nisy – Šumperku, kterému se říká „Malá Vídeň”.'
    },
    'header-description1': {
      pl: 'W ramach projektu „Śladami Małego Wiednia i Śląskiego Rzymu” współfinansowanego z programu Interreg VA Republika Czeska-Polska, realizowanego wspólnie przez partnerskie miasta Nysa i Szumperk powstała gra terenowa, która ma za zadanie uatrakcyjnić i wzbogacić ofertę turystyczną miasta i jest jednym z produktów tego projektu.”.',
      cz: 'V rámci projektu „Po stopách Malé Vídně a Slezského Říma” spolufinancovaného z programu Interreg VA Česká republika-Polsko, realizovaného společně partnerskými městy Nisa a Šumperk, vznikla terénní hra, jejímž úkolem je zatraktivnit a obohatit turistickou nabídku města a je jedním z produktů tohoto projektu.'
    },
    'header-description2': {
      pl: 'Wybierz miasto, które chcesz odwiedzić i rozwiązać quiz wiedzy o nim.  Jeśli korzystasz z komórki zapraszamy na spacer po atrakcjach Nysy i Sumperka ponieważ aby odpowiedzieć na pytania musisz znajdować się w okolicy wybranego obiektu.',
      cz: 'Vyberte si město, které chcete navštívit a o němž chcete vyřešit vědomostní kvíz. Pokud používáte mobilní telefon, zveme Vás na procházku po zajímavostech Nisy a Šumperku. Totiž abyste mohli správně odpovědět na otázky, musíte se nacházet v blízkosti zvoleného objektu. '
    },
    'select-trip': {
      pl: 'Wybierz wycieczkę',
      cz: 'Vyberte si výlet'
    },
    'nysa': {
      pl: 'Nysa',
      cz: 'Nisa'
    },
    'nysa-des': {
      pl: 'Śladami śląskiego Rzymu',
      cz: 'Po stopách Slezského Říma'
    },
    'sumperk-des': {
      pl: 'Śladami małego Wiednia',
      cz: 'Po stopách Malé Vídně'
    },
    'start-trip': {
      pl: 'Rozpocznij wycieczkę',
      cz: 'Zahajte výlet'
    },
    'see-ranking': {
      pl: 'Zobacz ranking',
      cz: 'Viz pořadí'
    },
    'terrain-game': {
      pl: 'Gra terenowa',
      cz: 'Terénní hra'
    },
    'correct-answer': {
      pl: 'Udzielono poprawnej odpowiedzi',
      cz: 'Byla dána správná odpověď'
    },
    'location-error-permisson': {
      pl: 'Zezwól przeglądarce na dostęp do lokalizacji aby opowiedzieć na pytania.',
      cz: 'Povolit prohlížeči přístup k místu, aby odpovídal na otázky.'
    },
    'location-error-cant-get-data': {
      pl: 'Trwa wyznaczanie Twojej aktualnej pozycji.',
      cz: 'Aktuální pozice je určena.'
    },
    'wrong-answer': {
      pl: 'Udzielono błędnej odpowiedzi',
      cz: 'Byla dána nesprávná odpověď'
    },
    'come-closer': {
      pl: 'Znajdujesz się za daleko obiektu. Podejdź bliżej, aby odpowiedzieć na pytanie.',
      cz: 'Jste příliš daleko od objektu. Přijďte blíže, abyste odpověděli na tuto otázku.'
    },
    'panorama': {
      pl: 'Panorama',
      cz: 'Panoráma'
    },
    'answer': {
      pl: 'Odpowiedz na pytanie',
      cz: 'Odpovězte na otázku'
    },
    'back-to-question': {
      pl: 'Powrót do opisu',
      cz: 'Odpovězte na otázku'
    },
    'position': {
      pl: 'Miejsce',
      cz: 'Místo'
    },
    'nick': {
      pl: 'Nick',
      cz: 'Nick'
    },
    'wynik': {
      pl: 'Wynik',
      cz: 'Výsledek'
    },
    'ranking': {
      pl: 'Ranking',
      cz: 'Hodnocení'
    },
    'your-score': {
      pl: 'Twój wynik to',
      cz: 'PořVáš výsledek jeadí'
    },
    'points': {
      pl: '- punkty: ',
      cz: '- bodů: '
    },
    'result-text': {
      pl: 'Aby znaleźć się na liście najlepszych graczy podaj swoje imię lub nick, a następnie udostępnij swój wynik znajomym na Facebooku',
      cz: 'Chcete-li zadat seznam nejlepších hráčů, zadejte své jméno nebo přezdívku a poté sdílejte své skóre se svými přáteli na Facebooku'
    },
    'give-nick': {
      pl: 'Podaj swój nick',
      cz: 'Dej svou přezdívku'
    },
    'add-to-ranking': {
      pl: 'Dodaj wynik do rankingu',
      cz: 'Přidejte výsledek do žebříčku'
    },

    'hide-route-to-start': {
      pl: 'Ukryj trasę do startu',
      cz: 'Skryjte trasu, kterou chcete rozjet'
    },

    'calculate-route-to-start': {
      pl: 'Wyznacz trasę do startu',
      cz: 'Vypočtěte trasu, kterou chcete vyrazit'
    },
    'share': {
      pl: 'Udostępnij',
      cz: 'Sdílejte'
    },
    'end-quiz': {
      pl: 'Zakończ quiz',
      cz: 'Ukončete kvíz'
    },
    'validate-form': {
      pl: 'Należy wpisać przynajmniej 3 znaki. Dozwolone są litery, cyfry i spacje.',
      cz: 'Musí být zadány alespoň tři znaky. Písmena, čísla a mezery jsou povoleny.'
    }
  };

  public getText(name, lang = this.configurationService.data.language) {
    return this.texts[name][lang];
   }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/services/translates.service.ts